import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AdminComponent} from './admin.component';
import {adminDeclaredComponentsList, AdminRoutingModule} from './admin.module.routing';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../../@hornbillfx/components/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NotificationService} from './service/notification.service';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from './admin-services/auth.service';
import {AdminDashboardService} from './admin-services/admin-dashboard.service';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {ProgressModule} from '../../@pages/components/progress/progress.module';
import {OrganisationService} from './organisation/services/organisation.service';
import {AdminCourseService} from './course/services/admin-course.service';
import { CourseManagementService } from './admin-services/course-management.service';
import { UserDashboardcardsModule } from '../../user-module/user-dashboard/user-dashboardcards/user-dashboardcards.module';
import { QuizReviewComponent } from './dashboard/quiz-review/quiz-review.component';

@NgModule({
  imports: [
    CommonModule,
    AdminRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxDatatableModule,
    ProgressModule,
    // UserDashboardcardsModule
  ],
  declarations: [AdminComponent,
    adminDeclaredComponentsList,
    QuizReviewComponent],
  providers: [
    NotificationService, NgbActiveModal,
    NgbModal, AuthService,
    AdminDashboardService,
    OrganisationService, AdminCourseService,CourseManagementService
  ],
  entryComponents:[QuizReviewComponent]
})
export class AdminModule {
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/admin.module.ts